export function setListingsMobileFilterViewState(payload) {
  return (dispatch) => {
    dispatch({
      type: 'SET_LISTINGS_MOBILE_FILTER_VIEW_STATE',
      payload,
    })
  }
}

export function setListingMobileBookingEnquiryFormViewState(payload) {
  return (dispatch) => {
    dispatch({
      type: 'SET_LISTING_MOBILE_BOOKING_ENQUIRY_FORM_VIEW_STATE',
      payload,
    })
  }
}
